// extracted by mini-css-extract-plugin
export var divider = "_ds-7";
export var itemsToggle = "_ds-8";
export var mergeModal = "_ds-1";
export var optionCard = "_ds-4";
export var radioGroup = "_ds-6";
export var radioOption = "_ds-0";
export var selected = "_ds-5";
export var shipmentOptions = "_ds-2";
export var tableOptions = "_ds-3";